import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgStar(props) {
	return (
		<SvgIcon {...props}>
			<path
				d="M12 16.5l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L12 4.5l2.351 4.764 5.257.764-3.804 3.708.898 5.236z"
				stroke="currentColor"
				strokeWidth={1.2}
				fill="none"
				fillRule="evenodd"
			/>
		</SvgIcon>
	)
}

export default SvgStar
